import { render, staticRenderFns } from "./consent-structure-additional-information-card.vue?vue&type=template&id=0307ff86"
import script from "./consent-structure-additional-information-card.vue?vue&type=script&lang=js"
export * from "./consent-structure-additional-information-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports